import { render, staticRenderFns } from "./GenerateReport.vue?vue&type=template&id=5b10a962&scoped=true&"
import script from "./GenerateReport.vue?vue&type=script&lang=js&"
export * from "./GenerateReport.vue?vue&type=script&lang=js&"
import style0 from "./GenerateReport.vue?vue&type=style&index=0&id=5b10a962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10a962",
  null
  
)

export default component.exports